<template>
  <div class="level" :class="extraclass">
    <div class="level-left">
      <slot></slot>
    </div>
    <div class="level-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LevelLeft',
  props: {
    extraclass: {
      type: String,
    },
  },
};
</script>
